<script setup lang="ts">
import { computed, type PropType } from 'vue';
import { inputProps } from 'naive-ui';
import GaiaInput from './GaiaInput.vue';

/**
 * A password field. Every one in the app reveals on click, so that lives here
 * rather than being restated at each site — not because the sites disagreed
 * (they don't), but so the reveal affordance has one definition to change.
 */
const props = defineProps({
  ...inputProps,
  showPasswordOn: {
    type: String as PropType<'click' | 'mousedown'>,
    default: 'click',
  },
});

// `type` is set on the template below, after the spread, so it always wins.
const inputBindings = computed<Record<string, unknown>>(() => ({ ...props }));
</script>

<template>
  <gaia-input v-bind="inputBindings" type="password" />
</template>
